import Vue from 'vue';

Vue.filter('trueFalseTranslator', (value: string) => {
  if (value) {
    return 'Ja';
  }
  return 'Nein';
});
